// 土耳其语
import constant from '../../constants/lang/tr';
import newLang from '../newLang/tr';
/* eslint-disable max-len */
export default {
  cfmoto: {
    ...(newLang.cfmoto || {}),
    constant,
    api: {
      http: {
        401: 'Lütfen önce giriş yapın',
        404: 'Veri yok',
        500: 'Sistem meşgul, lütfen daha sonra tekrar deneyin',
        504: 'İstek zaman aşımına uğradı',
        ERR_NETWORK: 'Ağ istisnası',
        ERR_NETWORK_UPLOAD: 'Yükleme başarısız oldu, lütfen başka bir ağ deneyin',
      },
    },
    title: '智能网联美国版管理后台',
    navbar: {
      dropdown: {
        updatePassword: '修改密码',
        switchLanguage: '切换语言',
        logout: '退出登录',
      },
    },
    router: {
      title: {
        'binding-agreement': '绑车协议',
        introduce: '介绍',
        lamp: 'Gösterge ışığı',
        download: 'CFMOTO RIDE APP Download',
        orderConfirm: 'Order Confirmation',
        ebook: 'ebook',
        list: 'ebook',
        pdf: 'PDF',
        feedback: 'Kayıtlar',
        'feedback-create': 'Geri bildirim',
        'feedback-supplement': 'Ek Geri Bildirim',
        'feedback-detail': 'Geri bildirim detayları',
        'feedback-result': 'Geri bildirim',
        guide: 'Yardım Merkezi',
        'guide-restScreen': 'Kurulum talimatları',
        'guide-overview': 'İşlevlere Genel Bakış',
        'guide-account': 'Hesap Hakkında',
        'guide-vehicle': 'Araç hakkında',
        'guide-meterSetting': 'Gösterge tablosu nasıl kurulur',
        'guide-vehicleSetting': 'Motosiklet nasıl kurulur',
        'guide-findNavigation': 'Motosiklet bulmak için nasıl gezinilir',
        'guide-vehicleNnavigation': 'Navigasyon nasıl kullanılır',
        'guide-cyclingRecord': 'Ride Geçmişi Hakkında',
        'guide-vehicleExperience': 'Kendi kendine araç muayenesi nasıl yapılır',
        'guide-useSetting': 'APP genel ayarları nasıl yapılır?',
        'guide-notice': 'Mesaj bildirimi nasıl görüntülenir ve ayarlanır?',
        'guide-about': 'APP hakkında',
        help: 'Yardım ve geri bildirim',
        'help-detail': 'Soru detayları',
        'myCar-unbinding': 'Bağlama çözme uygulayın',
        'myCar-unbinding-result': 'Bağlama çözme uygulayın',
      },
    },
    form: {
      cancel: 'İptal etmek',
      confirm: 'Onayla',
      submit: 'Göndermek',
      search: 'Aramak',
      language: {
        languageCode: {
          label: '请选择语言：',
          placeholder: '请选择语言',
        },
      },
    },
    rules: {
      language: {
        languageCode: {
          required: '请选择语言',
        },
      },
    },
    dialog: {
      language: '语言选择',
    },
    binding: {
      title: `Protokol`,
      text1: '1.	Telematik Hizmetleri',
      text2:
        'CFMOTO Powersports, Inc. (bundan sonra “ CFMOTO ” olarak anılacaktır ), CFMOTO aracını satın alan müşteriye (bundan böyle “Müşteri” olarak anılacaktır ) araç telematik hizmetleri sunmaktadır . Bu hizmetler için CFMOTO, Araç ve ilgili zaman dilimindeki sürüş davranışı hakkında Araç tarafından kaydedilen verileri kullanır. Ayrıntılı olarak, bu aşağıdaki verilerle ilgilidir:',
      text3: 'Kullanıcı Sürüş Davranışı Verileri : hızlanma, yavaşlama, hız, viraj, son sürüş süresi ve son sürüş mesafesi dahil .',
      text4:
        'Araç Durumu Verileri: 	Sürüş modu, kalan yakıt, anlık yakıt ekonomisi, kilometre, aracın gerçek zamanlı vitesi, motor hızı, lastik basıncı, lastik sıcaklığı, akü aktivasyon voltajı verileri dahil olmak üzere Aracın gerçek zamanlı durumunu ifade eder. , soğutma sıvısı sıcaklığı, elektronik kilit durumu, akıllı cihaz yazılım sürümü, akıllı cihazların sinyal gücü, ön panelin mevcut ayarı.',
      text5:
        ' Araç Alarm Verileri: 	motor sıcaklığı, aşırı hız, aşırı sürüş süresi, yüksek soğutma sıvısı sıcaklığı, anormal araç hareketi, anormal lastik basıncı, titreşim, boşaltma, çarpışma vb . gibi belirli veriler önceden ayarlanmış bir değeri aşarsa gönderilecek alarm verileri .',
      text6: ' Araç Arıza Bilgileri: 	Aracın her bir dahili parçası tarafından bildirilen arıza kodlarını ifade eder .',
      text7: 'Araç Konum Verileri: Aracın belirli coğrafi konumunu ifade eder.',
      text8: '1.1.	sağlama _ CFMOTO RIDE APP aracılığıyla araçla ilgili hizmetlerle Müşteri .',
      text9: '1.1.1.	APP aracılığıyla araçları uzaktan yönetebilir (aracın konumunu görüntüleme, araç bilgilerini ve işlevlerini ayarlama, araç durumunun uzaktan kumandası vb. dahil).',
      text10: '1.1.2.	Bir araç bulmak amacıyla araçlar arasındaki mesafenin hesaplanması ve yaya navigasyon dahil olmak üzere navigasyon sırasında rota planlamasının sağlanması .',
      text11: `1.2.	Aracın durumuna göre Müşteri'ye gerekli bildirimlerin yapılması .`,
      text12: '1.2.1.	CFMOTO, araç bakımıyla ilgili Müşteri bildirimlerini sonlandıracaktır (örneğin, Müşterinin kullandığı toplam mesafeye, Müşterinin aracı satın aldığı zamana, araç bakımı için süre veya sürüş mesafesi gerekliliklerine göre) .',
      text13: '1.2.2.	Araç verilerine bağlı olarak , CFMOTO Müşteriye anormal durum bildirimleri gönderecektir ; müşteri hizmetleri sağlamak ve aracın takip optimizasyonunu sağlamak için (modele bağlı olarak) OEM tarafından veri analizi dahil .',
      text14: '1.3.	Araçla ilgili ciddi bir kaza bildirmesi durumunda kazanın nedeninin analiz edilmesinde destek .',
      text15: `1.3.1.	sırasında Aracın devrilmesi veya yan yatması gibi ciddi bir Araç kazası durumunda CFMOTO, kazanın Araçtaki bir kusurdan mı yoksa başka koşullardan mı kaynaklandığının açıklığa kavuşturulmasında talep üzerine Müşteriye destek olacaktır. Talep, Müşteri tarafından Araç Satış Sözleşmesinde belirtilen yerel distribütör / satış ortağı aracılığıyla CFMOTO'ya iletilecektir.`,
      text16: '1.3.2.	Mevcut veriler buna izin verdiği ölçüde, CFMOTO, kazanın nedeni ile ilgili verileri değerlendirecek ve Müşteriye ilgili bir rapor sağlayacaktır.',
      text17: '1.4.	Araç kaybolduktan sonra Müşterinin Aracı kurtarması için yardım .',
      text18: '1.4.1.	Araç kaybolursa, CFMOTO talep üzerine ve varsa, Müşteriye Aracın konum verilerini ve Aracın diğer yararlı durum verilerini (son etkinleştirme konumu, mevcut araç durumu vb.) sağlayacaktır.',
      text19: `1.4.2.	Talep, Müşteri tarafından Araç Satış Sözleşmesinde belirtilen yerel distribütör / satış ortağı aracılığıyla CFMOTO'ya iletilecektir.`,
      text20: '1.5.	Satış sonrası sorunların raporlanması .',
      text21: '1.5.1.	CFMOTO, Aracın aksamlarının arızalanması durumunda Araç tarafından gönderilen hata kodu bildirimlerini uzaktan toplar ve ilgili bilgileri Müşterinin talebi üzerine doğrudan Müşteriye sunar.',
      text22: `1.5.2.	Talep, Müşteri tarafından Araç Satış Sözleşmesinde belirtilen yerel distribütör / satış ortağı aracılığıyla CFMOTO'ya iletilecektir.`,
      text23: '2.	Hizmetin Kısıtlamaları ve İstisnaları',
      text24: '2.1.	Hizmetler araç verilerinin doğru sağlanmasına bağlı olduğundan, Araçta yapısal veya diğer teknik değişikliklerin hizmetlerin sağlanmasını sınırlayabileceği veya hatta imkansız hale getirebileceği açıkça belirtilir.',
      text25: `2.2.	3. şahıs verilerinin veya telekomünikasyon ağlarının performansı nedeniyle bu tür hizmetlerin sağlanamadığı durumlarda , CFMOTO'nun herhangi bir sorumluluğu hariçtir.`,
      text26: '3.	Mahremiyet',
      text27: `CFMOTO aracıyla bağlantılı olarak işlerken geçerli veri koruma düzenlemelerine uyacaktır . C FMOTO'nun gizlilik politikasının şartları, bu CFMOTO RIDE UYGULAMASINDA belirtilmektedir . Gizlilik politikasına ek olarak , bu bildirim gizlilik politikasına uygundur . Ayrıca Müşteri , bu bildirimin kapsamına girmeyen veri işlemeyle ilgili bazı içerikler için gizlilik politikasına başvurabilir .`,
      text28: '4.	Müşteri servisi',
      text29: `4.1.	, gizlilikle ilgili sorularını, yorumlarını veya endişelerini CFMOTORIDEAPP@cfmotousa.com adresine göndermekten çekinmeyebilir veya CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447 adresine yazabilir . (888) 823-6686'da CFMOTO Müşteri İlişkileri. `,
      text30: '5.	revizyonlar _',
      text31: `5.1.	CFMOTO RIDE'da yayınlayacağız. Uygulama ve/veya uygun şekilde bunu yapmadan önce bildirimde bulunun.`,
    },

    atmosphere: {
      desTitle: '功能说明',
      setINfo: 'Yeni ayarlar, araç çalıştırıldıktan sonra 1-3 dakika içinde geçerli olacaktır, lütfen aracın iyi bir sinyal konumunda olduğundan emin olun.',
      setSuccess: 'başarıyla ayarla',
      sure: 'Emin',
      confirm: 'Teyit etmek',
      cancel: 'İptal etmek',
      cContent: 'Ayarlar henüz kaydedilmedi, kaydetmek istiyor musunuz?',
      save: 'Ayarları kaydet',
      introduce1: 'Otomatik kilit açma talimatlarına yakın',
      introduce2: 'otomatik kapanma talimatları',
      introduce3: 'Otomatik uyandırma talimatları',
      introduce4: 'Gecikmeli ışıklar kapalı',
      content1: {
        msg1: `İşlev açıldıktan sonra, cep telefonu Bluetooth 'u açar ve APP çalışmaya devam eder. Araca uzaktan yaklaşırken, aracın kilidi otomatik olarak açılabilir ve açılabilir.`,
        msg2: 'Normalde kilidi açılmamışsa ve açılmamışsa, kilidini açmak ve açmak için araç güç düğmesine basın',
        msg3: 'Yakınlık otomatik kilit açma, bluetooth bağlantısı kesilmeden önce sadece bir kez tetiklenecektir',
      },
      content2: {
        msg1: 'İşlev açıldıktan sonra, aracın üç koşulu kapatıldıktan sonra araç 5 saniye sonra otomatik olarak kapanır, araç hızı 0 ve tapınak düştü',
        msg2: 'Otomatik kapanma döneminde aracın çalıştırılması, aracın hızı 0 değil veya tapınak kaldırıldığında otomatik kapanma iptal edilir',
      },
      content3: {
        msg1: `İşlev açıldıktan sonra, araç kapatıldığında, cep telefonu Bluetooth 'u açar ve APP çalışmaya devam eder veya fiziksel anahtarı taşır. Araca uzaktan yaklaşırken, araç ışıkları konukları ağırlamak için yanıp sönecektir`,
        msg2: 'Sık tetikleyicilerin araç güç kaybına neden olmasını önlemek için, karşılama işlevi 30 saniye içinde iki kez tetiklendikten sonra, 30 dakika sonrasına kadar devam etmez',
      },
      content4: {
        msg1: 'Fonksiyon açıldıktan sonra, araç kapatıldıktan sonra uzak ve kısa farlar 10 saniye boyunca otomatik olarak yanacaktır.',
      },
    },
    feedback: {
      label: {
        type: 'Geri bildirim türü (tek seçenek)',
        content: 'Sorun açıklaması',
        fileList: 'Lütfen bir resim',
        fileList2: '(Maks. 4 resim / 1 video)',
        feedbackCreate: 'Geri bildirim için tıklayın',
        feedbackSupplement: 'Ek Geri Bildirim',
        backHome: 'Ana sayfaya geri dön',
        vehicle: 'ilgili araç',
        selectVehicle: 'araç seç',
      },
      placeholder: {
        'content.bug': 'Sorunun hızlı bir şekilde bulunmasına ve giderilmesine yardımcı olmak için lütfen oluşma zamanını, APP sürümünü, cep telefonu modelini, çalışma yolunu ve sorun açıklamasını ayrıntılı olarak açıklayın!',
        'content.suggest': 'Değerli önerilerde bulunmaya hoş geldiniz, fikirlerinizi ciddiyetle değerlendireceğiz',
        'content.vehicle': 'Lütfen ne zaman olduğunu, nasıl olduğunu ve sorunu açıklayın',
        'content.other': 'Lütfen ne zaman olduğunu, nasıl olduğunu ve sorunu açıklayın',
        'content.supplement': 'Lütfen sorunun açıklamasını ekleyin',
        vehicle: 'Lütfen bir araç seçin',
      },
      rules: {
        'type.required': 'Lütfen bir geri bildirim türü seçin',
        'content.required': 'Lütfen sorununuzun açıklamasını girin',
        'fileList.uploading': 'Yükleniyor, lütfen bekleyin',
        'fileList.maxSize': 'Yüklenen dosya çok büyükdür',
        'fileList.overType': 'Desteklenmeyen format ı',
        'fileList.maxCount': 'Yükleme sayısı sınırı aşıyor',
        'fileList.acceptImageVideo': 'Görüntü seçerken video seçilemiyor',
        'vehicle.required': 'Lütfen bir araç seçin',
      },
      message: {
        empty: 'Şu anda herhangi bir geri bildirim kaydı bulunmamaktadır.',
        finish: 'Yanıt',
        loading: 'Yükleniyor',
        uploadFailed: 'Yükleme başarısız oldu',
        tip: 'Hesabınızın güvenliğini korumak için lütfen hesap şifreleri vb. gibi hassas kişisel bilgileri buraya göndermeyin. ',
        feedbackSuccess: 'Geri bildirim alındı',
        'submit.error': 'Feedback başarısız oldu',
        'submit.success': 'Geri bildirim alındı',
      },
    },
    guide: {
      label: { giveFeedback: 'Çözülmedi, geri bildirim vermek istiyorum' },
    },
    help: {
      label: {
        history: 'Arama kayıtları',
        cancel: 'iptal',
        yes: 'Evet',
        no: 'Numara',
        unresolved: 'Hala çözemiyor musun? Tıklamak',
        submitFeedback: 'Geri bildirim gönder',
      },
      placeholder: {
        search: 'Aramak',
        'content.required': 'Lütfen anahtar kelime girin',
      },
      message: {
        empty: 'İlgili içerik yok',
        empty2: 'Anahtar kelimeleri değiştirmeyi öner veya',
        finish: 'Yanıt',
        historyDelete: 'Tüm arama kayıtları silinsin mi?',
        isHelpful: 'Yardımcı olur mu?',
      },
    },
    unbinding: {
      label: {
        vin: 'şasi numarası',
        realName: 'Tam adınız',
        email: 'E-posta adresi',
        phone: 'Telefon numarası',
        areaCode: 'Ülke kodu',
        identity: 'Tanılama',
        drivingLicense: 'Araç Kayıt Belgesi.',
        backHome: 'Ana sayfaya geri dön',
        areaCodeTitle: 'Ülke kodu',
        latterTitle: 'Fark etme',
        agree: ' Onay',
        disagree: 'Katılmıyorum',
        agreeCheckLabel: ' okudum ve kabul ediyorum',
        agreeCheckTitle: 'Aracın serbest bırakılması için başvuru talimatları',
      },
      placeholder: {
        vin: "Lütfen VIN'i girin",
        realName: 'Lütfen gerçek adınızı girin',
        email: 'lütfen e-mail adresinizi giriniz',
        phone: 'Lütfen telefon numaranızı girin',
        identity: 'Kimlik kartı, sürücü belgesi veya pasaportun kişisel tanıtım bilgilerini içeren ana sayfası.',
        drivingLicense: "Araç Kayıt Belgesi'nin ana sayfası, sahibin adı ve VIN bilgisiyle birlikte.",
      },
      rules: {
        'agree.required': 'Lütfen okuyun ve kabul edin',
        'vin.required': "Lütfen VIN'i girin",
        'vin.pattern': 'Yanlış VIN, lütfen kontrol edin.',
        'realName.required': 'Lütfen gerçek adınızı girin',
        'email.required': 'lütfen e-mail adresinizi giriniz',
        'email.pattern': 'E-posta adresi formatı yanlış, lütfen kontrol edin.',
        'phone.required': 'Lütfen telefon numaranızı girin',
        'phone.pattern': 'Telefon numarası format hatası, lütfen kontrol edin',
        'fileList.maxCount': 'Yükleme sayısı sınırı aşıyor',
        'fileList.uploading': 'Yükleniyor, lütfen bekleyin',
      },
      message: {
        imgUploadFailed: 'Resim yüklenemedi',
        securityMessage: 'Yukarıdaki bilgiler yalnızca kimlik doğrulama için kullanılır, CFMOTO bilgilerinizi korur.',
        resultMessage: 'Başvuru materyallerini mümkün olan en kısa sürede doğrulayacağız, lütfen bildirim çubuğuna veya APP mesaj merkezine zamanında dikkat edin.',
        loading: 'Yükleniyor',
      },
    },
  },
};
